import JsEncrypt from 'jsencrypt'
import { decrypt as aesDecrypt, encrypt as aesEncrypt } from 'crypto-js/aes'
import UTF8, { parse } from 'crypto-js/enc-utf8'
import pkcs7 from 'crypto-js/pad-pkcs7'
import ECB from 'crypto-js/mode-ecb'

const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAt/p5o8nVVuwCZpFwryiZ
NpAgWndDqkCK4CPMaAFMb1StsdbIgUnLTa5KCMSwnugzRWbaz6pcuYLjdlENDoOH
21Aj2nN6tBqOog5/bQUhVcZ3jRtps5pv8/VhW4kUB8kCmp3wFBEXHIeHs/tnlyhK
Ej3d3ZR9zlue6XQgouUaW4BrQgjrZb4XtWYkTIsaq1jocVwrJFgD0KmhJOcJvgyY
1Usmz6j66uqL9Dmd59TgB7Xtl+H6a3PGZ5BwnK001XinmKuPaQmMA9IaxntATKHC
dDcBgtLfK1cXx8hx/1Owod06RpfndstA922hIa/IAm1+Mo4u172wtPqw9o9d53gE
JwIDAQAB
-----END PUBLIC KEY-----`
const privateKey = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC8W/AOxv0FQa1g
X1kGdWMXmMZOeiM0Q8WyYt8+iOzCOQPJiFAbQHMQCaixfR1XhlPVa/C7JhQE3gCZ
DGSIzrbAqCe1PhGVVJMaWEq5rqrL9QTfjPfYAB2tM3Cu3GtHRH+G1y3xAdLv7FTy
KvWMaorDUa6pUEQHHSc1S1pjlq/kx/iH6RdXcadqPJsJOA2RZPlE9O4cCyTDN10j
1QJIzLCvA2Ue8d8PSVwqSloAbSrM2d4TnkWNwVCa03/Staovob4dosJhJxGTAoMR
Vw5Ng/q+KLvcSIZhoWgVEGhU7g8/wcdk8nyb6DXXBAbbz+GHe/9gozUQXqXTUXT7
KdT+GpspAgMBAAECggEBAILUGNkqvXN5OsNFdsBVqI4rPxIjI3CZ4icVJZp54HjG
wSqp03oaOdFZ5CHjlQ3F71S9tGdI+36l9CRZxzp+2dDW+z2X7v6Zz9LsoHp4J4mi
lc/wSfVtny8+G3ZZAuptWWZ+7xoG+kxLCnVqAUOWfOtNQNO5PIb0aNdLj2y8rU9p
okWBimwwHSKuvoSNV1ghvijoycB7Pjbr0M52vAPhlZwq/VxOGoWLvdnBJwJL3Tf8
ejx6QCWphaO+2yxLlZcPsvMt2P+IejtXT139DGzKfAibccHz7ctf8ewE7Ax5ZvL/
kG08mMG0UIZ1jHlqbiIcs5nICN0zHUBwj9w/PsmcVQECgYEA+hQsyGo08OefAC7S
xy3SiyhkZvSMywD25xW7ohphnGXN49Apz4N6IXJ9fWp7kiK4U3BNjYZQ96Cu7PK8
aWTD9bO2iqvBQb4+4aUpfLbzz9ax/qjHIqBCVPYkNJeCgGJnJsGOcLo4uXNZ50qh
SeqOoXHggBxryHVMQVr6zyBKHp0CgYEAwNGn4fiEBD1DKnJPKZBVBteCS7a3rUAU
r60OP7pavTIUhJiXs6dPE0ZWh82JZkC1Ap/H3+RKlNSvVSyZxWliuHh+0gsNe/Iu
BQDZYGcDebYchLT1SdgmT5yW8YFH/um8JjCuEXhVIYlVQN3O5gHTmY32yrMBBe3q
HYILavT3ov0CgYEArsrRLlfFnyhVozwXCS7G/YsC+k8t5WpMKOKw3jHQTg9+JCBI
SQndoGk0uydlLZRk/7T8D9J031AJVAapmITczuyIx04bawc9TlwxrkD2Eyw+BwAT
B+m500ajsbrAdVnSPW2GUNZodX7htN8d8tsmTEObJhA3acpKvVeI/KLWC6UCgYAJ
x5h4QZ6QiHrroDibpxJo8m1NYcsXInTqJCDg4pbPmcaoowSuvAGqvJqO8MHTSdzk
cS42EOInglISQ9zYwmubZ6EnDiB09OeYoV5lIVRvy+jOYk8+m5P13b9aKHB6YWiF
l1p80FmhBdIpJBbmW5lb5HNr/IBEyLhjHsFtf1dAEQKBgGyzW0vJORiSBd/DApar
7jNFxxH3CAy6WPdw7w9gOSrP7h0kzKmYapdG87ZgRsRvmM6wBcdrJlEqyf3YGuR3
T5tnxbbRGr4NLKLvKbF7iXGKdOMhhfIAr9LU4ndyP5io9FqA5JwDofXcP0rjXDDt
BpO47jHud0CI1q8xgFMJc6+s
-----END PRIVATE KEY-----`

// 加密方法
export const RSAencrypt = (pas) => {
  const jse = new JsEncrypt()
  // 设置公钥
  jse.setPublicKey(publicKey)
  // console.log('加密：'+jse.encrypt(pas))
  return jse.encrypt(pas)
}

// 解密方法
export const RSAdecrypt = (pas, iv = privateKey) => {
  const jse = new JsEncrypt()
  // 私钥
  jse.setPrivateKey(iv)
  // console.log('解密：'+jse.decrypt(pas))
  return jse.decrypt(pas)
}
/**
 * @description 通过给定的字符串截取密钥以及内容
 * @param {*} str 原始字符串
 * @returns {object} {key: 密钥, content: 内容}
 */
export const handleOriginStr = (str) => {
  if (!str) {
    return {
      key: '',
      content: ''
    }
  }
  const len = str.length
  return {
    key: str.substring(0, 16) + str.slice(-16),
    content: str.substring(16, len - 16)
  }
}
/**
 * @description AES解密 已知加密数据以及密钥
 * @param {*} data 加密数据
 * @param {*} iv 密钥
 * @returns any
 */
export const ECBDecryptByData = (data, iv) => {
  const utf8Key = parse(iv)
  return aesDecrypt(data, utf8Key, { mode: ECB, padding: pkcs7 }).toString(UTF8)
}
/**
 * @description AES解密 数据以及密钥需要通过返回解析
 * @param {*} enStr 加密数据以及密钥原始数据
 * @returns any
 */
export const ECBDecryptByStr = (enStr) => {
  const { key, content } = handleOriginStr(enStr)
  const utf8Key = parse(key)
  return aesDecrypt(content, utf8Key, { mode: ECB, padding: pkcs7 }).toString(UTF8)
}

// AES加密长文本
export const setAesEncrypt = (data) => {
  const key = parse('dklUbSIQiiqwtmo0CpcOQTnjm5ZycUDj') // 确保长度为 16/24/32 字节
  // 使用 ECB 模式（无需 IV）
  const encrypted = aesEncrypt(data, key, {
    mode: ECB,
    padding: pkcs7
  })
  return encrypted.toString()
}
